<template>
  <v-avatar
    :color="borderColor"
    :size="style.size"
    v-on="on || $listeners"
  >
    <v-avatar :color="color" :size="innerSize">
      <span :class="textClass" :style="textStyle">
        <slot></slot>
      </span>
    </v-avatar>
  </v-avatar>
</template>

<script>
const defaultStyle = {
  size: 48,
  textSize: 16,
};
const mediumStyle = {
  size: 40,
  textSize: 14,
};
const smallStyle = {
  size: 28,
  textSize: 10,
};

export default {
  name: 'Avatar',
  props: {
    color: {
      type: String,
      default: 'grey lighten-2',
    },
    borderColor: {
      type: String,
      default: 'white',
    },
    medium: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: null,
    },
    borderSize: {
      type: Number,
      default: 4,
    },
    textClass: {
      type: String,
      default: 'font-weight-bold grey--text',
    },
    textSize: {
      type: Number,
      default: null,
    },
    on: {
      type: Object,
      default: null,
    },
  },
  computed: {
    style() {
      if (this.size !== null && this.textSize !== null) {
        return { size: this.size, textSize: this.textSize };
      } else if (this.size !== null) {
        return { size: this.size };
      } else if (this.textSize !== null) {
        return { textSize: this.textSize };
      } else if (this.medium) {
        return mediumStyle;
      } else if (this.small) {
        return smallStyle;
      }
      return defaultStyle;
    },
    innerSize() {
      return this.style.size - this.borderSize;
    },
    textStyle() {
      return {
        fontSize: this.style.textSize + 'px',
      };
    },
  },
};
</script>
